export default __webpack_public_path__ + "static/media/rt_layout_draft.14df7749.svg";